module.exports = __webpack_public_path__ + "static/media/105-aland-islands.3ae19981.svg";